import {FaPizzaSlice, FaHamburger} from 'react-icons/fa'
import {GiBullHorns, GiChopsticks} from 'react-icons/gi'
import styled from "styled-components"
import {NavLink} from 'react-router-dom'


function Category() {
  return (
    <List>
        <SLink to={'/cusine/Italian'}>
        <FaPizzaSlice />
        <h4>Italian</h4>
        </SLink>
        <SLink to={'/cusine/American'}>
        <FaHamburger />
        <h4>American</h4>
        </SLink>
        <SLink to={'/cusine/Spanish'}>
        <GiBullHorns />
        <h4>Spanish</h4>
        </SLink>
        <SLink to={'/cusine/Chinese'}>
        <GiChopsticks />
        <h4>Chineses</h4>
        </SLink>
    </List>
  )
}

const List = styled.div`
display:flex;
justify-content:center;
margin: 2rem 0rem;
`

const SLink = styled(NavLink)`
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
border-radius:50%;
margin-right:2rem;
text-decoration: none;
background: linear-gradient(35deg, #656565, #313131);
width:6rem;
height:6rem;
cursor:pointer;
transform:scale(0.8);
color:white;

&.active{
  background: linear-gradient(to right, #f27121, #e94057);
}
`

export default Category